import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorDialogComponent} from 'src/app/modules/common/dialogs/error-dialog/error-dialog.component';
import {TableControl} from 'src/app/modules/common/models/TableControl';
import {UtilService} from 'src/app/modules/common/services/util.service';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {PolicyProductPersonLinksDTO} from '../../../models/PolicyProductPersonLinksDTO';
import {PolicyService} from '../../../services/policy.service';
import {MatTableDataSource} from '@angular/material/table';
import {PolicyDTO} from '../../../models/PolicyDTO';

@Component({
  selector: 'app-add-policy-view',
  templateUrl: './add-policy-view.component.html',
  styleUrls: ['./add-policy-view.component.scss', '../../../../../../styles/global/_add-view-edit-styles.scss']
})
export class AddPolicyViewComponent implements OnInit {
  policyProductPersonLinksTableControl: TableControl;
  isSelected = true;
  heading: string;
  backPageName: string;
  tabName: string;
  helpInfo: HelpDTO[];
  policyId: number;
  policyDTO: PolicyDTO;
  isBillToGroup: string;
  policyNameFormControl: FormControl;
  policyNumberFormControl: FormControl;
  administratorFormControl: FormControl;
  policyholderFormControl: FormControl;
  renewalOfPolicyFormControl: FormControl;
  renewedByPolicyFormControl: FormControl;
  payerFormControl: FormControl;
  currencyFormControl: FormControl;
  policyStartDateFormControl: FormControl;
  coverStatusFormControl: FormControl;
  policyEndDateFormControl: FormControl;
  statusStartDateFormControl: FormControl;
  policyActivationDateFormControl: FormControl;
  statusEndDateFormControl: FormControl;
  policyApplicationDateFormControl: FormControl;
  underwritingTypeFormControl: FormControl;
  brokerFormControl: FormControl;
  proRataTypeFormControl: FormControl;
  brokerCommissionFormControl: FormControl;
  billingDayNumberFormControl: FormControl;
  premiumBillingIntervalFormControl: FormControl;
  firstBillingDateFormControl: FormControl;
  generalFormGroup: FormGroup;
  statusFormGroup: FormGroup;
  premiumParametersFormGroup: FormGroup;
  selectedCoverStatuses = [];
  selectedPolicyProductPersonLinks: PolicyProductPersonLinksDTO[] = [];

  policyProductPersonLinksDisplayedColumns: string[] = [
    'select',
    'personName',
    'nationalIdNumber',
    'product',
    'coverStatus',
    'startAndEndDate',
    'nominatedBeneficiaryNationalIdNumber'
  ];
  policyProductPersonDataSource = new MatTableDataSource<PolicyProductPersonLinksDTO>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private helpService: HelpService,
    private router: Router,
    private policyService: PolicyService,
    private utilService: UtilService) {
    this.tabName = 'policy';
    this.backPageName = 'enterprise-management';
    this.route.params.subscribe(params => {
      this.policyId = params.id;
    });
    this.isBillToGroup = 'No';
    this.policyNameFormControl = new FormControl();
    this.policyNumberFormControl = new FormControl();
    this.administratorFormControl = new FormControl();
    this.policyholderFormControl = new FormControl();
    this.renewalOfPolicyFormControl = new FormControl();
    this.renewedByPolicyFormControl = new FormControl();
    this.policyStartDateFormControl = new FormControl();
    this.coverStatusFormControl = new FormControl();
    this.policyEndDateFormControl = new FormControl();
    this.statusStartDateFormControl = new FormControl();
    this.policyActivationDateFormControl = new FormControl();
    this.statusEndDateFormControl = new FormControl();
    this.policyApplicationDateFormControl = new FormControl();
    this.payerFormControl = new FormControl();
    this.currencyFormControl = new FormControl();
    this.underwritingTypeFormControl = new FormControl();
    this.brokerFormControl = new FormControl();
    this.proRataTypeFormControl = new FormControl();
    this.brokerCommissionFormControl = new FormControl();
    this.billingDayNumberFormControl = new FormControl();
    this.premiumBillingIntervalFormControl = new FormControl();
    this.firstBillingDateFormControl = new FormControl();
    this.generalFormGroup = this.formBuilder.group({
      policyName: this.policyNameFormControl,
      policyNumber: this.policyNumberFormControl,
      administrator: this.administratorFormControl,
      policyholder: this.policyholderFormControl,
      renewalOfPolicy: this.renewalOfPolicyFormControl,
      renewedByPolicy: this.renewedByPolicyFormControl,
      payer: this.payerFormControl,
      currency: this.currencyFormControl
    });
    this.statusFormGroup = this.formBuilder.group({
      policyStartDate: this.policyStartDateFormControl,
      coverStatus: this.coverStatusFormControl,
      policyEndDate: this.policyEndDateFormControl,
      statusStartDate: this.statusStartDateFormControl,
      policyActivationDate: this.policyActivationDateFormControl,
      statusEndDate: this.statusEndDateFormControl,
      policyApplicationDate: this.policyApplicationDateFormControl
    });
    this.premiumParametersFormGroup = this.formBuilder.group({
      underwritingType: this.underwritingTypeFormControl,
      broker: this.brokerFormControl,
      proRataType: this.proRataTypeFormControl,
      brokerCommission: this.brokerCommissionFormControl,
      billingDayNumber: this.billingDayNumberFormControl,
      premiumBillingInterval: this.premiumBillingIntervalFormControl,
      firstBillingDate: this.firstBillingDateFormControl
    });
  }

  ngOnInit(): void {
    this.getHelpInfo('Policy');
    if (this.route.snapshot.url[1].path === 'edit-policy') {
      this.heading = 'Edit Policy';
      this.getPolicyById(this.policyId);
    }
    else {
      this.heading = 'Add Policy';
    }
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  getPolicyById(policyId: number): void {
    this.policyService.getPolicy(policyId).subscribe(
      (response: PolicyDTO) => {
        this.policyDTO = response;
        this.setFormsForEdit(response);
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  setFormsForEdit(data) {
    this.policyNameFormControl.setValue(data.name);
    this.policyNumberFormControl.setValue(data.number);
    this.administratorFormControl.setValue(data?.administrator?.name);
    this.policyholderFormControl.setValue(data?.policyholder?.name);
    this.renewalOfPolicyFormControl.setValue(data?.renewalOfPolicy?.name);
    this.renewedByPolicyFormControl.setValue(data?.renewedByPolicy?.name);
    this.payerFormControl.setValue(data?.payer?.name);
    this.currencyFormControl.setValue(data?.currency?.name);
    this.policyStartDateFormControl.setValue(data.startDate && data.startDate > 0 ? new Date(data.startDate) : null);
    this.policyEndDateFormControl.setValue(data.endDate && data.endDate > 0 ? new Date(data.endDate) : null);
    this.policyActivationDateFormControl
      .setValue(data.activationDate && data.activationDate > 0 ? new Date(data.activationDate) : null);
    this.policyApplicationDateFormControl
      .setValue(data.applicationDate && data.applicationDate > 0 ? new Date(data.applicationDate) : null);
    this.underwritingTypeFormControl.setValue(data?.underwritingType?.name);
    this.brokerFormControl.setValue(data?.broker?.name);
    this.proRataTypeFormControl.setValue(data?.proRataType?.name);
    this.brokerCommissionFormControl.setValue(data.brokerCommission);
    this.billingDayNumberFormControl.setValue(data.billingDayNumber);
    this.premiumBillingIntervalFormControl.setValue(data?.premiumBillingInterval?.name);
    this.firstBillingDateFormControl.setValue(data.firstBillingDate && data.firstBillingDate > 0 ? new Date(data.firstBillingDate) : null);
    this.isBillToGroup = data.billToGroup ? 'Yes' : 'No';
    this.selectedCoverStatuses = data.coverStatuses;
    this.selectedPolicyProductPersonLinks = data.policyProductPersonLinks;
    this.policyProductPersonDataSource = new MatTableDataSource<PolicyProductPersonLinksDTO>(this.selectedPolicyProductPersonLinks);
    this.policyProductPersonDataSource.sort = this.sort;
    this.policyProductPersonDataSource.paginator = this.paginator;
    if (this.selectedCoverStatuses && this.selectedCoverStatuses.length) {
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      const sortArray = this.selectedCoverStatuses.sort(function(a, b) {
        return b.startDate - a.startDate;
      });
      for (let i = 0; i < this.selectedCoverStatuses.length - 1; i++) {
        this.selectedCoverStatuses[i + 1].endDate =
          new Date(new Date(this.selectedCoverStatuses[i].startDate)
            .setDate(new Date(this.selectedCoverStatuses[i].startDate).getDate() - 1));

      }
      this.coverStatusFormControl.setValue(sortArray[0]?.coverStatusDTO.name);
      this.statusStartDateFormControl.setValue(sortArray[0].startDate ? new Date(sortArray[0].startDate) : null);
      this.statusEndDateFormControl.setValue(sortArray[0].endDate ? new Date(sortArray[0].endDate) : null);
    }
    this.setDataSource();
    this.blurPolicyNameHeading();
  }

  getCoveredStatusDisplayString(coveredStatus) {
    return `${coveredStatus.coverStatusDTO.name}:  ${this.utilService.dateFormat(coveredStatus.startDate)} - ${coveredStatus.endDate ? this.utilService.dateFormat(coveredStatus.endDate) : ''}`;
  }

  blurPolicyNameHeading() {
    if (this.route.snapshot.url[1].path === 'edit-policy') {
      this.heading = `Edit Policy - ${this.policyNameFormControl.value}`;
    }
    else {
      this.heading = `Add Policy - ${this.policyNameFormControl.value}`;
    }
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo ? helpInfo.inputInfo : '';
    }
    return message;
  }

  handleError(errorMessage: string) {
    this.dialog.open(ErrorDialogComponent, {
      width: '40vw',
      data: errorMessage
    });
  }

  getPersonFullName(person) {
    const middleName = person.middleName ? person.middleName : '';
    return `${person.firstName} ${middleName} ${person.lastName}`;
  }

  setDataSource() {
    this.policyProductPersonDataSource = new MatTableDataSource<PolicyProductPersonLinksDTO>(this.selectedPolicyProductPersonLinks);
    this.policyProductPersonDataSource.sort = this.sort;
    this.policyProductPersonDataSource.paginator = this.paginator;
  }

  getStartAndEndDate() {
    return `${this.statusStartDateFormControl.value ? this.utilService.dateFormat(this.statusStartDateFormControl.value) : ''} - ${this.statusEndDateFormControl.value ? this.utilService.dateFormat(this.statusEndDateFormControl.value) : ''}`;
  }

  pageChanged(event) {
    this.policyProductPersonLinksTableControl.pageNumber = event.pageIndex;
    this.policyProductPersonLinksTableControl.pageSize = event.pageSize;
  }

  onClickExit() {
    this.router.navigate(['/enterprise-management'], {queryParams: {tab: this.tabName}});
  }
}
